import Component from 'gia/Component';

export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      toc: {},
      buttonOpenToc: {},
      buttonCloseToc: {},

      plus: {},
      minus: {}
    };
    this.onDocClick = null;
  }

  mount() {
    let that = this;

    this.ref.buttonOpenToc.addEventListener('click', function() {
      if (that.ref.toc.classList.contains('hidden')) {
        that.ref.toc.classList.remove('hidden');
        that.ref.minus.classList.remove('hidden');
        that.ref.plus.classList.add('hidden');
        // add event listener to close toc when clicking outside of it
        that.onDocClick = function(event) {
          if (!that.ref.toc.contains(event.target) && !that.ref.buttonOpenToc.contains(event.target)) {
            that.ref.toc.classList.add('hidden');
            that.ref.minus.classList.add('hidden');
            that.ref.plus.classList.remove('hidden');
            document.removeEventListener('click', that.onDocClick);
            that.onDocClick = null;
          }
        };
        document.addEventListener('click', that.onDocClick);

      } else {
        that.ref.toc.classList.add('hidden');
        that.ref.minus.classList.add('hidden');
        that.ref.plus.classList.remove('hidden');
        // remove event listener to close toc when clicking outside of it
        if (that.onDocClick) {
          document.removeEventListener('click', that.onDocClick);
          that.onDocClick = null;
        }
      }

    });

    // this.ref.buttonCloseToc.addEventListener('click', function() {
    //   that.ref.toc.classList.add('-translate-x-full');
    //   that.ref.toc.classList.remove('translate-x-0');
    // });
  }


}